module.exports = __webpack_public_path__ + "media/Office_OUT.7c3e0566.mp4";